module.exports = __webpack_public_path__ + "static/media/dloja.72059916.png";